export const calculateTotalPages = (totalItems, pageSize) => {
    if (!totalItems || !pageSize) return 0;
    return Math.ceil(totalItems / pageSize);
  };
  
  export const getCurrentPage = (currentPage, totalPages) => {
    if (!totalPages) return 1;
    return Math.min(Math.max(1, currentPage), totalPages);
  };